if (!customElements.get('ag-product-tabs')) {
  class AgProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          this.tabs[next].focus();
          this.select(this.tabs[next]);
        });
      });
    }

    select(selected) {
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
    }
  }
  customElements.define('ag-product-tabs', AgProductTabs);
}
